<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Checkout" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
    <div class="col-xl-8">
        <div class="card">
            <div class="card-body checkout-tab">

                <div class="step-arrow-nav mt-n3 mx-n3 mb-3">
                    <ul ngbNav #customNav="ngbNav" [(activeId)]="tabId" (navChange)="onNavChange($event)"
                        class="nav nav-pills custom-nav nav-justified" role="tablist">
                        <li [ngbNavItem]="1" class="nav-item">
                            <a ngbNavLink class="nav-link fs-15 p-3" data-bs-toggle="tab" role="tab">
                                <i
                                    class="ri-user-2-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                Personal Info
                            </a>
                            <ng-template ngbNavContent>
                                <div>
                                    <h5 class="mb-1">Billing Information</h5>
                                    <p class="text-muted mb-3">Please fill all information below</p>
                                </div>

                                <div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="mb-3">
                                                <label for="billinginfo-firstName" class="form-label">First Name</label>
                                                <input required #name="ngModel"
                                                    [ngClass]="{ 'is-invalid': (name.invalid && ((name.dirty || name.touched) || submitted == true))}"
                                                    class="form-control" type="text" [(ngModel)]="userModel.name"
                                                    placeholder="Enter First Name"
                                                    i18n-placeholder="@@Common_EnterFirstName" mask='A* A* A* A* A* A*'
                                                    [dropSpecialCharacters]="false" />
                                                <div *ngIf="(name.invalid  || userModel.name == undefined) && ((name.dirty || name.touched) || submitted == true)"
                                                    class='invalidInputTextMessage'>
                                                    <!-- this is the style of form-invalid -->
                                                    <div *ngIf="name.errors?.['required']">
                                                        <div i18n="@@Error_FirstNameRequired">First name is Required
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6">
                                            <div class="mb-3">
                                                <label for="billinginfo-lastName" class="form-label">Last Name</label>
                                                <input required #lastname="ngModel"
                                                    [ngClass]="{ 'is-invalid': (lastname.invalid && ((lastname.dirty || lastname.touched) || submitted == true))}"
                                                    class="form-control" type="text" [(ngModel)]="userModel.lastName"
                                                    placeholder="Enter Last Name"
                                                    i18n-placeholder="@@Common_EnterLastName" mask='A* A* A* A* A* A*'
                                                    [dropSpecialCharacters]="false" />
                                                <div *ngIf="(lastname.invalid  || userModel.lastName == undefined)&& ((lastname.dirty || lastname.touched) || submitted == true)"
                                                    class='invalidInputTextMessage'>
                                                    <!-- this is the style of form-invalid -->
                                                    <div *ngIf="lastname.errors?.['required']">
                                                        <div i18n="@@">Last name is Required</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="mb-3">
                                                <label for="billinginfo-email" class="form-label">Email
                                                </label>
                                                <input class="form-control" type="text" required [pattern]=emailPattern
                                                    #email="ngModel"
                                                    [ngClass]="{ 'is-invalid': (email.invalid && ((email.dirty || email.touched) || submitted == true))}"
                                                    placeholder="Enter Email"
                                                    i18n-placeholder="@@ContactPopUp_PlaceHolder_email"
                                                    [(ngModel)]="userModel.email" />
                                                <div *ngIf="((email.invalid || userModel.email == undefined) && ((email.dirty || email.touched) || submitted == true))"
                                                    class='invalidInputTextMessage'>
                                                    <div *ngIf="email.errors?.['required'] else elseEmail">
                                                        <div i18n="@@Error_EmailRequired">Email is Required</div>
                                                    </div>
                                                    <ng-template #elseEmail>
                                                        <div *ngIf="email.invalid">
                                                            <div i18n="@@ContactPopUp_Error_EmailInvalid">Email Invalid
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6">
                                            <div class="mb-3">
                                                <label for="billinginfo-phone" class="form-label">Phone</label>
                                                <input type="text" class="form-control" id="billinginfo-phone"
                                                    #phone="ngModel"
                                                    [ngClass]="{ 'is-invalid': (phone.invalid && ((phone.dirty || phone.touched) || submitted == true))}"
                                                    placeholder="Enter phone number" value={{userModel.phoneNumber}}
                                                    mask="(000) 000 0000" [(ngModel)]="userModel.phoneNumber"
                                                    [dropSpecialCharacters]="false">
                                                <div *ngIf="(phone.invalid && ((phone.dirty || phone.touched) || submitted == true))"
                                                    class='invalidInputTextMessage'>

                                                    <div *ngIf="phone.invalid">
                                                        <div i18n="">Phone Number Invalid</div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div *ngIf="isGuest" >
                                        <div>
                                            <h5>Account Information</h5>
                                            <p class="text-muted mb-3">Please fill in the account information so you can
                                                access your requests later</p>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 mb-3" >
                                                <label for="newpasswordInput" class="form-label"
                                                    i18n="@@Register_text_NewPW"> New Password
                                                </label>
                                                <div class="position-relative auth-pass-inputgroup">
                                                    <input autocomplete="off"
                                                        [type]="passwordFieldTextTypeNew ? 'text' : 'password'"
                                                        class="form-control" id="newpasswordInput"
                                                        placeholder="Enter password"
                                                        i18n-placeholder="@@Common_EnterPassword" required
                                                        [(ngModel)]="userNewPassword"
                                                        [ngClass]="{ 'is-invalid': submitted && (passwordNonValid !== undefined) }">
                                                    <button
                                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                        type="button" id="password-addon"><i class="mdi align-middle"
                                                            [ngClass]="{'mdi-eye-off-outline': !passwordFieldTextTypeNew, 'mdi-eye-outline': passwordFieldTextTypeNew}"
                                                            (click)="passwordFieldTextTypeNew= !passwordFieldTextTypeNew"></i></button>
                                                    <div class="invalid-feedback">
                                                        {{passwordNonValid}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 mb-3" >

                                                <label for="confirmPasswordInput" class="form-label"
                                                    i18n="@@Register_text_ConfirmPW">Confirm
                                                    Password</label>
                                                <div class="position-relative auth-pass-inputgroup">
                                                    <input autocomplete="off"
                                                        [type]="passwordFieldTextTypeConfirmation ? 'text' : 'password'"
                                                        class="form-control" id="confirmPasswordInput"
                                                        placeholder="Enter password"
                                                        i18n-placeholder="@@Common_EnterPassword" required
                                                        [(ngModel)]="userConfirmPassword"
                                                        [ngClass]="{ 'is-invalid': submitted && (confirmPasswordNonValid !== undefined) }">
                                                    <button
                                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                        type="button" id="password-addon"><i class="mdi align-middle"
                                                            [ngClass]="{'mdi-eye-off-outline': !passwordFieldTextTypeConfirmation, 'mdi-eye-outline': passwordFieldTextTypeConfirmation}"
                                                            (click)="passwordFieldTextTypeConfirmation= !passwordFieldTextTypeConfirmation"></i></button>
                                                    <div class="invalid-feedback">
                                                        {{confirmPasswordNonValid}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <h5>Billing Address</h5>
                                        <p class="text-muted mb-3">Please fill in the billing address</p>
                                    </div>
                                    <app-address [addressModel]="userModel.paymentInfo.billingAddress"
                                        [submitted]="submitted" [includeValidation]="true"></app-address>


                                    <div class="d-flex align-items-start gap-3 mt-2">

                                        <button type="button" class="btn btn-primary btn-label right ms-auto nexttab"
                                            [disabled]="checkoutDisabled" (click)="tabToPayment()"><i
                                                class="ri-bank-card-line label-icon align-middle fs-16 ms-2"></i>Continue
                                            to Payment</button>
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="2" class="nav-item">
                            <a ngbNavLink class="nav-link fs-15 p-3" role="tab">
                                <i
                                    class="ri-bank-card-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                Payment Info
                            </a>
                            <ng-template ngbNavContent>

                                <div>
                                    <h5 class="mb-1">Payment Selection</h5>
                                    <p class="text-muted mb-3">Please select and enter your billing information</p>
                                </div>

                                <div class="row g-4 pb-3">
                                    <div class="col-lg-4 col-sm-6">
                                        <div data-bs-toggle="collapse" data-bs-target="#paymentmethodCollapse"
                                            aria-expanded="true" aria-controls="paymentmethodCollapse">
                                            <div class="form-check card-radio">
                                                <input id="paymentMethod02" name="paymentMethod" type="radio"
                                                    class="form-check-input" checked>
                                                <label class="form-check-label" for="paymentMethod02">
                                                    <span class="fs-16 text-muted me-2"><i
                                                            class="ri-bank-card-fill align-bottom"></i></span>
                                                    <span class="fs-14 text-wrap">Credit / Debit Card</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <app-creditcard [showUpdate]="true" [newCard]="newCard" [submitted]="submitted"
                                    [includeValidation]="true" [userCreditcard]="userModel.paymentInfo"
                                    (userCreditcardChange)="userModel.paymentInfo=$event"></app-creditcard>

                                <div class="d-grid d-sm-flex align-items-start gap-3 mt-4 justify-content-sm-between">
                                    <button [disabled]=isLoading type="button" class="btn btn-primary btn-label"
                                        (click)="tabToInfo()"><i
                                            class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>Back
                                        to
                                        Information</button>
                                    <button [disabled]=isLoading type="button" class="btn btn-primary btn-label right "
                                        (click)="tabToFinish()"><i
                                            class="ri-shopping-basket-line label-icon align-middle fs-16 ms-2"></i>Complete
                                        Order</button>
                                </div>

                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3" class="nav-item">
                            <a ngbNavLink class="nav-link fs-15 p-3" role="tab">
                                <i
                                    class="ri-checkbox-circle-line fs-16 p-2 bg-soft-primary text-primary rounded-circle align-middle me-2"></i>
                                Finish
                            </a>
                            <ng-template ngbNavContent>
                                <div class="text-center py-5">

                                    <div class="mb-4">
                                        <lord-icon src="https://cdn.lordicon.com/lupuorrc.json" trigger="loop"
                                            colors="primary:#0ab39c,secondary:#405189"
                                            style="width:120px;height:120px"></lord-icon>
                                    </div>
                                    <h5>Thank you! Your Order is Completed!</h5>
                                    <p class="text-muted">You will receive an order confirmation email with
                                        details of your order.</p>

                                    <!-- <h3 class="fw-semibold">Order ID: <a routerLink="/ecommerce/order-details" class="text-decoration-underline">VZ2451</a></h3> -->
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                </div>
                <!-- Tab panes -->
                <div class="tab-content">
                    <div [ngbNavOutlet]="customNav"></div>
                </div>

            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->

    <div class="col-xl-4">
        <div class="card">
            <div class="card-header">
                <div class="d-flex">
                    <div class="flex-grow-1">
                        <h5 class="card-title mb-0">Order Summary</h5>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <app-requisition-list-check-out #reqListComp [startStatus]=0></app-requisition-list-check-out>
            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->
</div>
<!-- end row -->